export enum NewOrderStep {
  SELECT_PRODUCTS = "SELECT_PRODUCTS",
  REVIEW = "REVIEW",
}
